import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DatabaseIcon } from 'lucide-react';
import { BrandMark, Sidebar } from './Sidebar';
import { FilterBar, type FilterMode } from './FilterBar';
import { MetricSelector } from '../dashboard/MetricSelector';
import { useMetricParam } from '../../hooks/useMetricParam';
export function AppShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  const [metric] = useMetricParam();
  const isDrilldown = pathname.startsWith('/territory/');
  const mode: FilterMode = isDrilldown ? 'entity' : metric === 'retention' ? 'retention' : 'full';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const subtitle = isDrilldown ? 'AOP performance, trends and comparison to the network' : metric === 'retention' ? 'Season-cohort retention of unique participants' : 'Choose a metric, review the 13-month trend, compare territories and drill into underperformance';
  return <div className="flex min-h-screen w-full bg-canvas text-ink" data-id="element-197" data-mp="2bea117oog4dh">
      <Sidebar data-id="element-198" data-mp="2gdmwuhxj0ls7" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-199" data-mp="2ge6494pjvrrz">
        <header className="border-b border-line bg-white px-4 md:px-6" data-id="element-200" data-mp="2gcuzp2oa6fzt">
          <div className="mx-auto max-w-[1440px]" data-id="element-201" data-mp="22l6n6ya4dpib">
            <div className="flex items-center justify-between py-3 lg:hidden" data-id="element-202" data-mp="26ntn7mgy2gql">
              <BrandMark data-id="element-203" data-mp="26lqmo8i6157m" />
            </div>
            <div className="flex flex-wrap items-end justify-between gap-3 pb-3 pt-4" data-id="element-204" data-mp="1snira50s2byk">
              <div data-id="element-205" data-mp="1xmvit32lg77h">
                <h1 className="text-[22px] font-bold tracking-tight text-navy md:text-2xl" data-id="element-206" data-mp="1xnewg7l7o9fp">
                  Franchise Performance Dashboard {isDrilldown && <span className="font-semibold text-ink-muted" data-id="element-207" data-mp="1jpgmrfhu516j">· Territory drilldown</span>}
                </h1>
                <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-208" data-mp="1nqsd5n8j9qfs">{subtitle}</p>
              </div>
              <div className="flex flex-wrap items-center gap-2 text-xs" data-id="element-209" data-mp="3dzkb234vi4yc">
                <span className="inline-flex items-center gap-1.5 rounded-md border border-caution/30 bg-caution-soft px-2.5 py-1 font-semibold text-caution" data-id="element-210" data-mp="3i276sf4o0a0t">
                  <DatabaseIcon className="h-3.5 w-3.5" data-id="element-211" data-mp="pv6kyoobnz6f" />
                  Sample data · not live
                </span>
                <span className="text-ink-muted" data-id="element-212" data-mp="lunscselup36">Prototype snapshot 10/16/26</span>
              </div>
            </div>
            <MetricSelector data-id="element-213" data-mp="gwm6y0tpidoj" />
          </div>
        </header>
        <FilterBar mode={mode} data-id="element-214" data-mp="1dlad9zw28ci4" />
        <main className="flex-1 px-4 py-5 md:px-6" data-id="element-215" data-mp="1dk90nqzebhya">
          <div className="mx-auto max-w-[1440px]" data-id="element-216" data-mp="19ix93fwyomng">{children}</div>
        </main>
      </div>
    </div>;
}